import type { CombinedError } from 'urql';

const INVALID_JWT_CODE = 'invalid-jwt';
const VALIDATION_FAILED_CODE = 'validation-failed';
const ACTIONABLE_SERVER_ERROR_CODES = new Set(['internal', 'unexpected']);

export function hasGraphQLErrorCode(error: CombinedError, code: string) {
  return error.graphQLErrors.some(
    (graphQLError) => graphQLError.extensions?.code === code,
  );
}

export function shouldAttemptAuthRecovery(error: CombinedError) {
  return (
    hasGraphQLErrorCode(error, INVALID_JWT_CODE) ||
    hasGraphQLErrorCode(error, VALIDATION_FAILED_CODE)
  );
}

export function shouldEndSessionAfterAuthRecovery(error: CombinedError) {
  return hasGraphQLErrorCode(error, INVALID_JWT_CODE);
}

export function getFirstGraphQLErrorMessage(error: CombinedError) {
  return error.graphQLErrors[0]?.message ?? error.message;
}

export function shouldCaptureGraphQLError(error: CombinedError) {
  return error.graphQLErrors.some((graphQLError) => {
    const code = graphQLError.extensions?.code;
    return typeof code === 'string' && ACTIONABLE_SERVER_ERROR_CODES.has(code);
  });
}
